import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import StudentDetails from './studentdetails';
import Dashboard from './dashboard';
import SalesTable from './tableformat';
import StudentDetails1 from './TestEntry';
function LeftNavApp() {
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setIsOpen(!mobile); // open on desktop, closed on mobile
    };
    handleResize(); // call on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <Router>
      <div style={styles.container}>

        
        {/* Sidebar */}
        <div
          style={{
            ...styles.sidebar,
            width: isOpen ? (isMobile ? '250px' : '220px') : '0',
          }}
        >
          {isMobile && (
            <button style={styles.closeBtn} onClick={toggleSidebar}>
              &times;
            </button>
          )}
          <nav style={styles.nav}>
            <ul style={styles.navList}>
              <li><Link to="/" style={styles.navLink}>Dashboard</Link></li>
              <li><Link to="/StudentDetails" style={styles.navLink}>Student Details</Link></li>
              <li><Link to="/SalesTable" style={styles.navLink}>Sales Table</Link></li>
              <li><Link to="/StudentDetails1" style={styles.navLink}>StudentDetails1</Link></li>
            </ul>
          </nav>
        </div>

        {/* Main content */}
        <div
          style={{
            ...styles.mainContent,
            marginLeft: isMobile ? '0' : '220px',
          }}
        >
          {isMobile && (
            <button style={styles.menuBtn} onClick={toggleSidebar}>
              &#9776;
            </button>
          )}
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/StudentDetails" element={<StudentDetails />} />
            <Route path="/SalesTable" element={<SalesTable />} />
            <Route path="/StudentDetails1" element={<StudentDetails1 />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    flexDirection: 'row',
  },
  sidebar: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    backgroundColor: '#333',
    color: 'white',
    overflowX: 'hidden',
    transition: '0.3s',
    paddingTop: '60px',
    zIndex: 1000,
  },
  closeBtn: {
    position: 'absolute',
    top: '10px',
    right: '20px',
    fontSize: '36px',
    color: 'white',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  navList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    width: '100%',
  },
  navLink: {
    padding: '10px 20px',
    textDecoration: 'none',
    color: 'white',
    display: 'block',
    textAlign: 'left',
  },
  mainContent: {
    flex: 1,
    padding: '20px',
    backgroundColor: '#f4f4f4',
   //backgroundColor:'#F54927',
    width: '100%',
    transition: 'margin-left 0.3s ease',
  },
  menuBtn: {
    fontSize: '30px',
    background: 'transparent',
    border: 'none',
    color: '#333',
    cursor: 'pointer',
    position: 'fixed',
    top: '20px',
    left: '20px',
    zIndex: 1100,
  },
};


export default LeftNavApp;
